import React from 'react';
import { C } from '../../utils/constants';
import "../../style.css";
import { FiChevronDown, FiSettings } from 'react-icons/fi';

const Badge = ({ c = C.teal, children }) => (
  <span style={{
    display: "inline-block",
    padding: "0.375rem 0.75rem",
    borderRadius: "9999px",
    fontSize: ".75rem",
    fontWeight: 600,
    lineHeight: "1rem",
    textTransform: "uppercase",
    background: `${c}22`,
    color: c,
    border: `1px solid ${c}44`
  }}>
    {children}
  </span>
);

const Card = ({ children, glow, style = {} }) => (
  <div style={{
    background: C.card,
    border: `1px solid ${glow ? glow + "44" : C.cardBorder}`,
    borderRadius: 11,
    padding: "16px 18px",
    boxShadow: glow ? `0 0 20px ${glow}12` : "none",
    fontFamily: "Inter, system-ui, -apple-system, sans-serif",
    ...style
  }}>
    {children}
  </div>
);

const Stat = ({ label, val, sub, col = C.white, icon }) => (
  <Card>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
      <div>
        <div style={{
          fontSize: 10,
          color: C.muted,
          textTransform: "uppercase",
          letterSpacing: ".1em",
          marginBottom: 6
        }}>{label}</div>
        <div style={{
          fontFamily: "Inter, system-ui, -apple-system, sans-serif",
          fontSize: 24,
          fontWeight: 800,
          color: col,
          lineHeight: 1
        }}>{val}</div>
        {sub && <div style={{ fontSize: 10, color: C.sub, marginTop: 4 }}>{sub}</div>}
      </div>
      {icon && <div style={{ fontSize: 18, opacity: .5 }}>{icon}</div>}
    </div>
  </Card>
);

const Btn = ({ children, onClick, v = "primary", sm, disabled }) => {
  const s = {
    primary:{
      borderRadius: ".4rem",
      height: "2.2rem",
      boxShadow: "none",
      display: "flex",
      alignItems: "center",
      gap: "3.8rem",
      padding: "0 .9rem",
      fontSize: ".85rem",
      cursor: "default",
      background: "#f97316",
      border: "none",
      color: "#fff",
    },
    teal: { background: `linear-gradient(135deg,${C.teal},#00a88c)`, color: "#041810", border: "none" },
    ghost: { background: "rgba(255,255,255,.06)", color: C.muted, border: `1px solid ${C.border}` },
    danger: { background: `rgba(255,80,80,.1)`, color: C.red, border: `1px solid rgba(255,80,80,.3)` },
    green: { background: `rgba(57,181,74,.12)`, color: C.green, border: `1px solid rgba(57,181,74,.3)` },
    purple: { background: `rgba(123,95,255,.12)`, color: C.purple, border: `1px solid rgba(123,95,255,.3)` },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{
      padding: sm ? "4px 11px" : "8px 16px",
      borderRadius: 7,
      cursor: disabled ? "not-allowed" : "pointer",
      fontSize: sm ? 10 : 12,
      fontWeight: 700,
      fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      letterSpacing: ".04em",
      transition: "all .18s",
      opacity: disabled ? .5 : 1,
      ...s[v]
    }}>
      {children}
    </button>
  );
};

const Toggle = ({ on, onChange }) => (
  <div onClick={() => onChange && onChange(!on)} style={{
    width: 32,
    height: 17,
    borderRadius: 9,
    cursor: "pointer",
    position: "relative",
    background: on ? C.teal : "rgba(255,255,255,.12)",
    transition: "background .25s",
    flexShrink: 0
  }}>
    <div style={{
      position: "absolute",
      top: 2,
      left: on ? 17 : 2,
      width: 13,
      height: 13,
      borderRadius: "50%",
      background: "#fff",
      transition: "left .25s",
      boxShadow: "0 1px 3px rgba(0,0,0,.3)"
    }} />
  </div>
);

const SectionHead = ({ title, sub, action }) => (
  <div style={{
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 18
  }}>
    <div>
      <div className='main-header' style={{
        color: C.white,
      }}>{title}</div>
      {sub && <div style={{ fontSize: ".875rem",lineHeight: "1.25rem", color: C.sub, marginTop: ".25rem" }}>{sub}</div>}
    </div>
    {action}
  </div>
);

const Tabs = ({ tabs, active, onChange }) => (
  <div style={{ display: "flex", gap: 5, marginBottom: 16, flexWrap: "wrap" }}>
    {tabs.map(t => (
      <button key={t} onClick={() => onChange(t)} style={{
        padding: "5px 13px",
        borderRadius: 7,
        border: "none",
        cursor: "pointer",
        fontSize: 11,
        fontWeight: 600,
        fontFamily: "Inter, system-ui, -apple-system, Segoe U, Roboto, Ubuntu, sans-serif",
        transition: "all .2s",
        background: active === t ? C.orange : "rgba(255,255,255,.06)",
        color: active === t ? "#fff" : C.muted
      }}>
        {t}
      </button>
    ))}
  </div>
);

const Modal = ({ title, onClose, children, w = 640 }) => (
  <div className="modal-overlay">
    <div className="modal-container" style={{ maxWidth: w }}>
      
      {/* Header */}
      <div className="modal-header">
        <h2 className="modal-title">{title}</h2>
        <button onClick={onClose} className="modal-close">✕</button>
      </div>

      {/* Body */}
      <div className="modal-body">
        {children}
      </div>
    </div>
  </div>
);

const Inp = ({ label, value, onChange, placeholder, type = "text", required }) => (
  <div className="form-group">
    {label && (
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
    )}

    <input
      type={type}
      value={value}
      onChange={e => onChange(e.target.value)}
      placeholder={placeholder}
      className="form-input"
    />
  </div>
);
const Sl = ({ label, value, onChange, opts, required }) => (
  <div className="form-group">
    {label && (
      <label className="form-label">
        {label} {required && <span className="required">*</span>}
      </label>
    )}

    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      className="form-select"
    >
      {opts.map(o => (
        <option key={o.v || o} value={o.v || o}>
          {o.l || o}
        </option>
      ))}
    </select>
  </div>
);

const ApigeeRef = ({ method, path }) => (
  <div style={{
    background: "rgba(0,201,167,.06)",
    border: `1px solid rgba(0,201,167,.2)`,
    borderRadius: 7,
    padding: "8px 12px",
    marginTop: 10
  }}>
    <div style={{
      fontSize: 8,
      color: C.teal,
      fontWeight: 700,
      letterSpacing: ".1em",
      marginBottom: 3
    }}>APIGEE X POLICY CALL</div>
    <div style={{
      fontSize: 10,
      color: C.muted,
      fontFamily: "Inter, system-ui, -apple-system, Segoe U, Roboto, Ubuntu, sans-serif"
    }}>{method} {path}</div>
  </div>
);

const pdC = {
  OpenAI: "#10a37f",
  Anthropic: "#cc774e",
  Google: "#4285f4",
  AWS: "#ff9900",
  Custom: C.purple
};

const PDot = ({ p }) => (
  <span style={{
    width: 7,
    height: 7,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 5,
    background: pdC[p] || C.muted
  }} />
);

const THead = ({ cols }) => (
  <thead>
    <tr style={{ borderBottom: `1px solid ${C.border}` }}>
      {cols.map(c => (
        <th key={c} style={{
          padding: "7px 10px",
          textAlign: "left",
          fontSize: 9,
          color: C.muted,
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: ".1em"
        }}>{c}</th>
      ))}
    </tr>
  </thead>
);

const CSTYLE = {
  tt: { background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 11 },
  grid: { stroke: "#1E3A5A" },
  tick: { fill: "#94A3B8", fontSize: 9 }
};

const sevC = {
  critical: C.red,
  high: C.orange,
  medium: C.amber,
  low: C.teal
};

const ConfigDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const options = [
    { v: "git", l: "Git Configuration" },
    { v: "gcs", l: "Google Cloud Storage" },
    { v: "standard", l: "API Standard Linting" },
    { v: "custom", l: "Api Custom Linting" },
  ];

  const toggle = () => setIsOpen(!isOpen);

  const select = (v) => {
    onChange(v);
    setIsOpen(false);
  };

  return (
    <div className="cd-container">
      {/* 🔹 Button */}
      <button 
      className={`cd-button ${value ? "cd-button-active" : ""}`} 
      onClick={toggle}>
        <FiSettings className="cd-icon" />

        <span>Config</span>

        <FiChevronDown
          className={`cd-caret ${isOpen ? "rotate" : ""}`}
        />
      </button>

      {/* 🔹 Dropdown */}
      {isOpen && (
        <div className="cd-dropdown">
          {options.map((opt) => (
            <button
              key={opt.v}
              onClick={() => select(opt.v)}
              className={`cd-item ${
                value === opt.v ? "active" : ""
              }`}
            >
              <FiSettings className="cd-item-icon" />
              {opt.l}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConfigDropdown;

export {
  Badge,
  Card,
  Stat,
  Btn,
  Toggle,
  SectionHead,
  Tabs,
  Modal,
  Inp,
  Sl,
  ApigeeRef,
  PDot,
  THead,
  CSTYLE,
  sevC,
  pdC,
  ConfigDropdown
};

